import guifan from "./guifan/index";
import biange from "./biange/index";
import dandang from "./dandang/index";
import wendu from "./wendu/index";
export default [
    ...guifan,
    ...biange,
    ...dandang,
    ...wendu
]
